<!-- 地方教材登录 -->
<template>
  <div class="place-login">
    <div class="window-box">
      <div class="window_con">
        <img class="window_bgone" :src="windowA" alt="" />
        <img class="window_bgtwo" :src="windowB" alt="" />
        <div class="window_title">
          {{ showWindow === 1 ? '欢迎登录' : '欢迎注册'
          }}<span>山东教育社刊物订购</span>
        </div>
        <div class="window_form">
          <transition name="fade">
            <p v-if="name">
              <i class="iconfont icongerenzhongxin"></i>
              <input type="text" pad="true" v-model="name" disabled v-support />
            </p>
          </transition>
          <p>
            <i class="iconfont icongerenzhongxin"></i>
            <input type="text" placeholder="请输入身份证号码" pad="true" v-model="idCard" @input="handleIdCardInput"
              v-support />
          </p>
          <p>
            <i class="iconfont iconpassword"></i>
            <input type="password" placeholder="默认密码为身份证后六位" pad="true" v-model="password" v-support
              autocomplete="new-password" />
          </p>
          <div class="window_btnbox clear">
            <p class="logbtn fl lingred" v-if="showWindow === 1" @click="login">
              登录
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import windowA from '@/assets/images/windowa.jpg'
import windowB from '@/assets/images/windowb.jpg'
import util from '../../assets/js/util'
let that
export default {
  name: 'material-login',
  data: function () {
    return {
      windowA, // 背景图a
      windowB, // 背景图b
      phone: '', // 手机号
      name: '', // 姓名
      idCard: '', // 身份证号码
      idCardLength: '', // 身份证号码
      password: '', // 密码
      checkCode: '请向右滑动验证', // 校验码
      codeText: '获取验证码', // 验证码内容
      msgCode: '', // 验证码
      ifPass: false, // 校验码状态
      startX: '', // 初始位置
      clientX: '', // 当前位置
      sending: false, // 正在发送验证码
      ifIe9: false, // 是否是ie11以下
      isSecond: false, // 是否是第二次发送验证码
      showWindow: 1, // 切换登录 和 注册
      cityList: [], // 城市列表
      cityId: '', // 选中城市Id
      unitList: [], // 单位列表
      company: '', // 单位名称
      idCardTimer: null
    }
  },
  created() {
    that = this
    this.showWindow = this.$route.query.showWindow
      ? this.$route.query.showWindow * 1
      : 1

    let userAgent = navigator.userAgent
    if (
      userAgent.indexOf('compatible') > -1 &&
      userAgent.indexOf('MSIE') > -1
    ) {
      this.ifIe9 = true
      return
    }

    // const protocol = window.location.protocol;
    // const host = window.location.host;
    // if ( util.isWX() && this.showWindow != 3 ) { window.location.href = 'http://wxzf.sdjys.org/wechat/openid?secret_key=StqVTlQQsF8F&uri=combine_material'; return null}
    // if (!util.IsPC() && !util.isWX()){ window.location.href = '/phone/place-login'; return null }
    // 手机端的对应页面
    this.requestList()
  },
  mounted() {
    if (this.showWindow == 3) document.title = '修改密码'
    that.initSlide()
  },
  watch: {
    idCard(newValue) {
      this.idCardLength = newValue.length
    }
  },
  methods: {
    // 初始化滑块
    initSlide: function () {
      this.ifPass = false
      this.startX = 0
      this.clientX = 0
    },
    // 初始化表单
    initForm: function () {
      this.phone = ''
      this.password = ''
      this.checkCode = '请向右滑动验证'
      this.msgCode = ''
      this.codeText = '获取验证码'
      this.ifPass = false
    },
    // 点下滑块
    downSlide: function (e) {
      if (!this.ifPass) {
        this.startX = e.clientX
        this.clientX = e.clientX
      }
      document.addEventListener('mousemove', this.moveSlide)
      document.addEventListener('mouseup', this.upSlide)
    },
    // 滑动滑块
    moveSlide: function (ev) {
      let event = ev || window.event
      if (
        !this.ifPass &&
        event.clientX - this.startX < 531 &&
        event.clientX - this.startX >= 0
      ) {
        this.clientX = event.clientX
      }
    },
    // 抬起鼠标
    upSlide: function (ev) {
      let event = ev || window.event
      if (!this.ifPass) {
        if (event.clientX - this.startX > 530) {
          this.clientX = 530 + this.startX
          this.ifPass = true
        } else {
          this.startX = 0
          this.clientX = 0
        }
        document.removeEventListener('mousemove', this.moveSlide)
        document.removeEventListener('mouseup', this.upSlide)
      }
    },
    // 点击忘记密码/注册
    changeType: function (e) {
      this.initSlide()
      this.initForm()
      this.showWindow = e
      // this.$emit('update:showWindow',e);
    },
    // 点击获取验证码
    requestCode: function () {
      if (!this.phone) {
        this.$message.error('请输入手机号')
        return false
      }
      if (!this.$store.state.regPhone.test(this.phone)) {
        this.$message.error('请输入正确的手机号')
        return false
      }
      if (!this.ifPass) {
        this.$message.error('请滑动验证')
        return false
      }
      that
        .$http({
          url: 'send_sms',
          showLoading: true,
          data: {
            phone: that.phone,
            type: that.showWindow - 1, // 1:注册;2:忘记密码
            send_type: that.isSecond ? 2 : 1,
          },
        })
        .then((res) => {
          that.isSecond = true
          let num = 60
          if (!this.sending) {
            this.sending = true
            let timer = setInterval(() => {
              if (num > 1) {
                num--
                this.codeText = num + '秒后重新获取'
              } else {
                num = 0
                this.codeText = '点击重新获取'
                this.sending = false
                clearInterval(timer)
              }
            }, 1000)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    // 监听身份证号输入
    handleIdCardInput: function (e) {
      this.idCardLength = this.idCard.length

      // 清除上一次防抖
      clearTimeout(this.idCardTimer)

      // 输入完成后再校验
      this.idCardTimer = setTimeout(() => {
        if (this.idCardLength !== 10 && this.idCardLength !== 18) {
          this.$message.error('请输入正确的身份证号码')
          return
        }

        this.handleFindInfo()
      }, 1200)
    },
    // 监听切换城市
    handleCityChange: function () {
      this.company = ''
      this.idCard = ''
    },
    // 查找身份证对应的身份信息
    handleFindInfo: function () {
      // const { cityId, company, idCard, $message } = this;
      const { idCard, $message } = this;
      let loadingInstance = Loading.service({
        lock: true,
        text: '查询中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // if (cityId && company && idCard) {
      if (idCard) {
        this.$http({
          // url: '/passport/search_name',
          url: '/common/search_name',
          isStudent: true,
          method: 'GET',
          params: {
            // city_id: cityId,
            // company,
            id_no: idCard,
          }
        })
          .then((res) => {
            if (res.result.exists) {
              this.name = res.result.student_name
            } else {
              this.$message.error('未查询到该身份证号码对应的信息')
              return false
            }
          })
          .catch((err) => {
          })
          .finally(() => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          })
      } else {
        // if (!cityId) {
        //   $message.error('请选择城市')
        //   return false
        // }
        // if (!company) {
        //   $message.error('请输入付款单位名称')
        //   return false
        // }
        if (!idCard) {
          $message.error('输入身份证号码')
          return false
        }
      }
    },
    // 点击登录按钮
    login: function () {
      if (!this.checkData()) {
        return false
      }
      // const { cityId, password, company, cityList, showWindow, idCard, name } = this
      const { password, showWindow, idCard, name } = this
      let data =
        showWindow == 3
          ? {
            // company,
            new_pwd: password,
            // city_id: cityId,
            id_no: idCard,
            name
          }
          : {
            // company,
            password,
            // city_id: cityId,
            id_no: idCard,
            name
          }

      const word = JSON.stringify(data)

      // 生成随机16位的iv字符串
      const iv = this.$utils.generateRandomString()

      that
        .$http({
          // url: 'passport/login',
          url: 'common/login',
          isStudent: true,
          data: {
            iv: iv,
            data: this.$encrypt(word, this.$aesKey, iv),
          },
          judgeMessage: false,
        })
        .then((res) => {
          sessionStorage['ifLogin'] = true
          // sessionStorage['city'] = cityList.find(
          //   (item) => item.city_id === cityId
          // )
          //   ? cityList.find((item) => item.city_id === cityId).city_name
          //   : ''

          sessionStorage['cartMount'] = res.result.cart_count
          sessionStorage['user'] = name

          sessionStorage['ifRead'] = res.result.is_read_letter
          sessionStorage['selectGrade'] = 0
          sessionStorage['gradeId'] = 'kong'

          // 标识 是 学生教材登录
          sessionStorage.setItem('isStudentOrder', '1')
          this.$store.commit('updateLoginMethod2', 1)
          this.$store.commit('updateUser', name)
          this.$router.push('/student/orders')
        })
        .catch((err) => {
          console.log(err);

          return false
          if (err.code === 201) {
            this.$confirm(
              '因平台升级，请您重新注册。感谢老客户的支持！',
              '提示',
              {
                confirmButtonText: '注册',
                cancelButtonText: '取消',
              }
            )
              .then(() => {
                this.password = ''
                this.$emit('update:showWindow', 2)
                this.showWindow = 2
              })
              .catch(() => { })
          } else if (err.code === 202) {
            this.$confirm(
              // '您当前的登录密码强度过弱，请先修改密码后再进行登录！',
              err.msg,
              '提示',
              {
                confirmButtonText: '修改密码',
                cancelButtonText: '取消',
              }
            )
              .then(() => {
                this.password = ''
                this.$emit('update:showWindow', 3)
                this.showWindow = 3
              })
              .catch(() => { })
          }
        })
    },
    // 验证表单
    checkData: function (e) {
      const { cityId, ifPass, company, password, $message, idCard } = this
      // if (!cityId) {
      //   $message.error('请选择城市')
      //   return false
      // }
      // if (!company) {
      //   $message.error('请输入单位名称')
      //   return false
      // }
      if (!idCard) {
        $message.error('请输入身份证号码')
        return false
      }
      // let idCardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      // if (!idCardReg.test(idCard)) {
      //   $message.error('请输入正确的身份证号码')
      //   return false
      // }
      if(this.idCardLength !== 10 && this.idCardLength !== 18) {
        this.$message.error('请输入正确的身份证号码')
        return false;
      }
      if (!password) {
        $message.error('请输入密码')
        return false
      }

      // 弱密码验证
      // if (
      //   this.showWindow != 1 &&
      //   !this.$utils.validatePassword(this.password)
      // ) {
      //   this.$confirm(
      //     '您的密码过于简单，为了您的账号安全，请设置至少8位的数字+字母组合的密码。',
      //     '提示',
      //     {
      //       confirmButtonText: '我知道了',
      //       cancelButtonText: '取消',
      //     }
      //   )
      //     .then(() => { })
      //     .catch(() => { })
      //   return false
      // }

      return true
    },
    // 点击修改密码
    modlog: function () {
      const {
        checkData,
        company,
        password,
        cityId,
        $message,
        login,
        showWindow,
        idCard
      } = this
      let data =
        showWindow == 3
          ? {
            company,
            new_pwd: password,
            city_id: cityId,
          }
          : {
            company,
            password,
            city_id: cityId,
          }

      const word = JSON.stringify(data)

      // 生成随机16位的iv字符串
      const iv = this.$utils.generateRandomString()

      if (checkData(1)) {
        that
          .$http({
            isStudent: true,
            url: 'passport/edit_pwd',
            showLoading: true,
            data: {
              iv: iv,
              data: this.$encrypt(word, this.$aesKey, iv),
            },
          })
          .then((res) => {
            $message({ type: 'success', message: '修改成功, 请重新登录' })
            this.showWindow = 1
            // login(data);
          })
          .catch((err) => { })
      }
    },
    // 模糊查询
    querySearchAsync(queryString, cb) {
      if (!this.cityId) {
        this.$message.error('请选择城市后，再输入付款单位名称')
        return
      }
      this.requestUnitList(cb)
    },
    handleSelect(ev) {
      this.company = ev
    },
    // 请求城市列表
    requestList: function () {
      this.$http({
        url: '/passport/cities',
        isStudent: true,
        method: 'GET',
      })
        .then((res) => {
          this.cityList = res.result
        })
        .catch((err) => {
          if (err.code == 201) {
            this.errorRequest = this.errorRequest + 1
            if (this.errorRequest < 5) {
              setTimeout(() => {
                this.requestList()
              }, 500)
            } else {
              this.$message.error('网络错误，请稍后重试')
            }
          }
        })
    },
    // 单位选择
    requestUnitList(cb) {
      const { cityId, company } = this
      // console.log(company)
      this.$http({
        url: '/passport/search_company',
        isStudent: true,
        method: 'GET',
        params: {
          city_id: cityId,
          company,
        },
      })
        .then(({ result }) => {
          this.unitList = result
          cb(result)
        })
        .catch((err) => {
          if (err.code == 201) {
            this.errorRequest = this.errorRequest + 1
            if (this.errorRequest < 5) {
              setTimeout(() => {
                this.requestList(cb)
              }, 500)
            } else {
              this.$message.error('网络错误，请稍后重试')
            }
          }
        })
    },
  },
}
</script>

<style scoped>
/*element select 样式重置*/
::v-deep .city-box .el-select .el-input--suffix .el-input__inner,
::v-deep .city-box .el-input .el-input__inner {
  height: 54px;
  font-size: 18px;
  border: 0;
  background: #f6f6f6;
  border-radius: 8px;
  padding-left: 58px;
}

::v-deep .city-box .el-input__prefix {
  left: 18px;
}

::v-deep .city-box .el-autocomplete {
  margin-left: 18px;
  flex: 1;
}

::v-deep .city-box .el-autocomplete .el-input__suffix .iconsousuo {
  line-height: 54px;
  font-size: 24px;
  color: #aaa;
}

.city-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.city-box .iconchengshi,
.city-box .icondanwei {
  line-height: 54px;
  font-size: 24px;
  color: #aaa;
}

.city-box .el-select {
  width: 194px;
}

.city-box .unit-box {
  flex: 1;
  padding-left: 16px;
}

.city-box .unit-box .el-select {
  width: 100%;
}

.place-login {
  min-height: calc(100vh - 130px);
  position: relative;
  width: 100%;
  padding-top: 160px;
  padding-bottom: 120px;
}

.place-login .window-box {
  position: relative;
  left: 0;
  top: 0;
  margin: 0 auto;
  padding: 24px 20px;
}

.window-box {
  overflow: hidden;
  padding: 0;
  border-radius: 6px;
  background: url(../../assets/images/logwindow.jpg) no-repeat;
  background-position: top;
}

.window.on .window-box {
  width: 750px;
  padding: 28px 25px;
}

.window_con {
  width: 100%;
  position: relative;
  background: #fff;
  padding: 55px;
  font-family: 'Microsoft YaHei';
  font-weight: 400;
}

.window_con .window_title {
  width: 100%;
  text-align: center;
  font-size: 30px;
  color: rgb(51, 51, 51);
  line-height: 2;
  margin-bottom: 30px;
}

.window_con .window_close {
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;
  font-size: 24px;
  color: #aaaaaa;
  padding: 10px;
}

.window_con .window_bgone {
  position: absolute;
  top: 0;
  left: 0;
}

.window_con .window_bgtwo {
  position: absolute;
  bottom: 0;
  right: 0;
}

.window_con .window_form {
  width: 100%;
  z-index: 100;
  position: relative;
}

.window_con .window_form>p {
  width: 100%;
  height: 54px;
  background: rgb(249, 249, 249);
  margin-bottom: 15px;
  border-radius: 8px;
}

.window_con .window_form>p i {
  display: inline-block;
  vertical-align: middle;
  margin: 0 20px;
  color: #aaaaaa;
  font-size: 24px;
}

.window_con .window_form>p .iconpassword {
  font-size: 26px;
}

.window_con .window_form>p input {
  display: inline-block;
  background: rgb(249, 249, 249);
  width: 500px;
  border: none;
  vertical-align: middle;
  line-height: 40px;
  font-size: 18px;
  height: 54px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.window_con .window_form .window_btnbox {
  padding: 25px 20px 0;
}

.window_con .window_form>span {
  display: inline-block;
  width: 100%;
  text-align: right;
}

.window_con .window_form .forbtn {
  display: inline-block;
  width: 70px;
  text-align: right;
  color: #999;
  font-size: 14px;
  cursor: pointer;
}

.window_con .window_form .forbtn:hover {
  color: rgb(63, 129, 210);
}

.window_con .window_form .logbtn,
.regbtn {
  display: inline-block;
  text-align: center;
  line-height: 60px;
  width: 100%;
  height: 60px;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  cursor: pointer;
}

.window_con .window_form .regbox {
  display: inline-block;
  width: 260px;
  height: 60px;
  border-radius: 30px;
}

.window_con .window_form .regbox .regbtn {
  line-height: 60px;
}

.window_con .window_form .window_shortp {
  width: 65%;
  position: relative;
}

.window_con .window_form .window_shortp input {
  width: 300px;
}

.window_con .window_form .window_shortp .window_require {
  position: absolute;
  right: -205px;
  top: 0;
  width: 185px;
  height: 60px;
  background: rgb(63, 122, 210);
  background: linear-gradient(-90deg,
      rgb(63, 122, 210) 0%,
      rgb(63, 166, 210) 100%);
  border-radius: 6px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  line-height: 60px;
  cursor: pointer;
}

.window_con .window_form .window_shortp .window_require:hover {
  color: rgb(14, 66, 144);
}

.window_con .window_form .window_shortp #verifyImg {
  display: inline-block;
  position: absolute;
  right: -205px;
  cursor: pointer;
  width: 185px;
  height: 60px;
  border: none;
  margin: 0;
}

.window_con .window_form #regsubbtn,
#msgbtn,
#addbtn,
#or-btn {
  display: block;
  width: 260px;
  height: 60px;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  cursor: pointer;
  margin: 0 auto;
}

.window_con .window_form .modbtn {
  display: block;
  margin: 0 auto;
}

.window_con .window_title span {
  font-weight: bold;
}

.silde-box {
  width: 100%;
  margin-bottom: 15px;
  height: 60px;
  background: rgb(249, 249, 249);
  border-radius: 6px;
  position: relative;
  text-align: center;
}

.silde-box>span {
  color: #333333;
  font-size: 16px;
  line-height: 60px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  z-index: 20;
}

.silde-box>span.on {
  color: #ffffff;
}

.silde-box .slide-btn {
  width: 52px;
  position: absolute;
  left: 4px;
  top: 4px;
  height: 52px;
  text-align: center;
  background: #ffffff;
  cursor: pointer;
  z-index: 50;
}

.silde-box .slide-btn i {
  font-size: 24px;
  line-height: 52px;
  color: #afafaf;
}

.silde-box .slide-bg {
  background: #88d267;
  height: 100%;
  width: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 60px;
  z-index: 10;
}

.silde-box .slide-btn.on i {
  color: #55a532;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
